export const tranlateInvalidInputs = invalidInputs => {
    const translated = {
        name: 'nome',
        title: 'título',
        slug: 'identificador',
        featureToggleKey: 'feature toggle',
        type: 'tipo',
        organization: 'organização',
        version: 'versão',
        walletToken: 'chave pública',
    }

    for (let input in translated) {
        if (invalidInputs.includes(input)) {
            const idx = invalidInputs.indexOf(input)
            invalidInputs[idx] = translated[input]
        }
    }

    return invalidInputs
}

export const formatInputsOnMessage = invalidInputs => {
    return invalidInputs && invalidInputs.length > 0 && invalidInputs.join(', ').replace(/, ((?:.(?!, ))+)$/, ' e $1')
}

export const is2xxStatus = status => makeNxxStatus(2, status)

export const is4xxStatus = status => makeNxxStatus(4, status)

const makeNxxStatus = (number, status) => status && Math.floor(status / 100) === number
